import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm">
                <i className="ri-download-2-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">磁力猫</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              专业的磁力链接搜索引擎，提供海量影视、音乐、软件、电子书等资源的磁力链接免费搜索与下载服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">资源分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                >
                  用户口碑
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer"
                >
                  使用帮助
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {currentYear} 磁力猫 ciligod.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}